import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { initTopbar } from './sections/topbar.js';
import { initClock } from './sections/clock.js';
import { initCursorBox } from './sections/cursor-box.js';
import { initMenu } from './sections/menu.js';
import { initSplits } from './sections/splits.js';
import { initReveals } from './sections/reveals.js';
import { initFeatureBg } from './sections/feature-bg.js';
import { initHeroZoom } from './sections/hero-zoom.js';
import { initConsent } from './sections/consent.js';

gsap.registerPlugin(ScrollTrigger);

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const lenis = new Lenis({
  duration: 1.15,
  smoothWheel: !prefersReducedMotion,
  smoothTouch: false,
  easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
});
window.__lenis = lenis;

lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);

initTopbar();
initClock();
initCursorBox();
initMenu();
initSplits();
initFeatureBg();
initConsent();

if (!prefersReducedMotion) {
  initReveals();
  initHeroZoom();
}

document.querySelectorAll('[data-year]').forEach((el) => {
  el.textContent = new Date().getFullYear();
});

window.addEventListener('load', () => {
  ScrollTrigger.refresh();
});
